/**
 * Initialize TOC active state management using Intersection Observer
 * Adds 'is-active' class to TOC items when their corresponding heading is in view
 */
function initTocActiveState() {
  const $tocItems = $('.js-toc-item');

  if ($tocItems.length === 0) {
    return;
  }

  // Create an array of heading elements and their corresponding TOC items
  const headingElements = [];

  $tocItems.each(function () {
    const $tocItem = $(this);
    const $tocLink = $tocItem.find('.c-toc__link');
    const href = $tocLink.attr('href');

    if (href && href.startsWith('#')) {
      const id = href.substring(1);
      const $heading = $(`#${id}`);

      if ($heading.length > 0) {
        headingElements.push({
          element: $heading[0],
          tocItem: $tocItem,
          id,
        });
      }
    }
  });

  if (headingElements.length === 0) {
    return;
  }

  // Create a map to track which headings are currently intersecting
  const intersectingHeadings = new Map();

  // Track scroll direction for better active state management
  let lastScrollTop = $(window).scrollTop();
  let isScrollingUp = false;
  let isClickScrolling = false; // Flag to indicate scroll was triggered by TOC click

  // Update scroll direction on scroll
  $(window).on('scroll', () => {
    const currentScrollTop = $(window).scrollTop();
    isScrollingUp = currentScrollTop < lastScrollTop;
    lastScrollTop = currentScrollTop;
  });

  // Intersection Observer options - more balanced margins for consistent behavior
  const observerOptions = {
    root: null, // Use viewport as root
    rootMargin: '-50px 0px -30% 0px', // Smaller top margin, larger bottom margin for better balance
    threshold: 0, // Trigger as soon as any part of the element is visible
  };

  // Create the Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const headingId = entry.target.id;
      const headingData = headingElements.find((h) => h.id === headingId);

      if (headingData) {
        if (entry.isIntersecting) {
          intersectingHeadings.set(headingId, headingData);
        } else {
          intersectingHeadings.delete(headingId);
        }

        // Update active TOC item based on intersecting headings
        updateActiveTocItem();
      }
    });
  }, observerOptions);

  // Function to update active TOC item
  function updateActiveTocItem() {
    // Skip automatic updates if we're in the middle of a click-triggered scroll
    if (isClickScrolling) {
      return;
    }

    // Remove active class from all TOC items
    $tocItems.removeClass('is-active');

    if (intersectingHeadings.size > 0) {
      const intersectingArray = Array.from(intersectingHeadings.values());
      let activeHeading;

      if (isScrollingUp && intersectingArray.length > 1) {
        // When scrolling up with multiple intersecting headings, prefer the bottom-most one
        [activeHeading] = intersectingArray.slice(-1);
      } else {
        // When scrolling down or single heading, use the topmost intersecting heading
        [activeHeading] = intersectingArray;
      }

      activeHeading.tocItem.addClass('is-active');
    } else if (headingElements.length > 0) {
      // If no headings are intersecting, check if we're past the last heading
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const lastHeading = headingElements[headingElements.length - 1];
      const $lastHeading = $(lastHeading.element);
      const lastHeadingTop = $lastHeading.offset().top;

      // Only activate last heading if we're significantly past it
      if (scrollTop + windowHeight > lastHeadingTop + 200) {
        lastHeading.tocItem.addClass('is-active');
      }
    }
  }

  // Observe all heading elements
  headingElements.forEach((headingData) => {
    observer.observe(headingData.element);
  });

  // Add click handlers for TOC links to handle manual navigation
  $tocItems.each(function () {
    const $tocItem = $(this);
    const $tocLink = $tocItem.find('.c-toc__link');

    $tocLink.on('click', () => {
      // Set clicked item as active immediately
      $tocItems.removeClass('is-active');
      $tocItem.addClass('is-active');

      // Prevent automatic updates during click-triggered scroll
      isClickScrolling = true;

      // Re-enable automatic updates after scroll animation completes
      // Use a longer timeout to ensure smooth scrolling is complete
      setTimeout(() => {
        isClickScrolling = false;
      }, 1000);
    });
  });
}

function initTocSidebar() {
  const $tocSidebar = $('.js-toc-sidebar');

  const tabletBreakpoint = 1025;

  if (window.matchMedia(`(min-width: ${tabletBreakpoint}px)`).matches) {
    return;
  }

  if ($tocSidebar.length === 0) {
    return;
  }

  $tocSidebar.on('click', () => {
    $tocSidebar.toggleClass('is-open');
  });
}
